<template>
    <div class="tabs-wrap">
        <v-tabs grow>
            <v-tab exact to="/mypage/cart/single">일반배송({{ summary.singleCartTotalCount }})</v-tab>
            <v-tab exact to="/mypage/cart/regular">정기배송({{ summary.regularCartTotalCount }})</v-tab>
            <v-tab exact to="/mypage/cart/stock">재고주문({{ summary.stockCartTotalCount }})</v-tab>
        </v-tabs>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        summary: {
            type: Object,
            default: () => ({
                singleCartTotalCount: 0,
                regularCartTotalCount: 0,
                stockCartTotalCount: 0,
            }),
        },
    },
    setup: () => ({}),
    data: () => ({}),
    computed: {},
    methods: {},
    watch: {},
    mounted() {},
    beforeUnmount() {},
};
</script>

<style lang="scss" scoped></style>
